module.exports = __webpack_public_path__ + "static/media/Arrow_up_ouline.4f5329d2.svg";